<template>
  <v-snackbar v-model="open" class="snackbar ml-8" :color="snackbarColor" :timeout="timeout" left>
    <span class="snackbar-text">{{ message }}</span>
    <mf-icon v-if="!btnText" class="cursor-pointer" color="branco" @click.stop="closeSnackbar()">close</mf-icon>
    <mf-button v-else text :dark="false" :color="btnColor" class="mr-2" :label="btnText" @click="clickButton()" />
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      open: false,
    }
  },
  watch: {
    open(value) {
      if (!value) {
        this.closeSnackbar()
      }
    },
  },
}
</script>
<style lang="scss">
.snackbar {
  font-family: 'Lato', sans-serif;
  z-index: 999999 !important;
}
</style>
